<script>
export default {
  name: 'status-card.generic',
  props: {
    status: {
      type: String,
      default: 'open'
    },
    updatedAt: {
      type: String
    }
  }
}
</script>
<template>
  <b-card
    :border-variant="$t(`web_form_status.${status}.color`)"
    no-body
    :title="updatedAt | moment('[Last Updated] DD/MM/YYYY hh:mm')"
    v-b-tooltip.hover
    class="m-0 p-0 border-0 bg-transparent shadow-none"
  >
    <b-card-body class="p-1">
      <div
        class="d-flex m-0 align-items-center font-size-14 justify-content-start"
      >
        <i
          :class="[
            $t(`web_form_status.${status}.icon`),
            'text-' + $t(`web_form_status.${status}.color`)
          ]"
          class="mx-1 font-size-16"
        ></i>
        <span class="small text-muted text-uppercase mx-1">{{
          $t(`web_form_status.${status}.text`)
        }}</span>
      </div>
    </b-card-body>
  </b-card>
</template>
